import { createObjectCRUDSlice } from './generators/objectCRUD.store'

const slice = createObjectCRUDSlice('stationDetail')

export const {
    stationDetailGetObjectAction,
    stationDetailSetObjectAction,
    stationDetailUpdateObjectAction,
    stationDetailAddObjectAction,
    stationDetailDeleteObjectAction,
    stationDetailObjectErrorAction,
    stationDetailObjectResetStateAction,
} = slice.actions

export default slice.reducer
